<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="controls/bs-form-textarea"></require>
  <require from="controls/bs-form-switch"></require>
  <require from="controls/as-widget-stack"></require>
  <require from="framework/html_behaviors/af-highlight.html"></require>

  <div class="as-form-section" style="border-bottom: 1px solid #e9ecef">
    <div class="d-flex">
      <h5 class="${!model.isActive ? 'sc-archived' : ''}" style="cursor: pointer; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-right: 15px;" click.delegate="questionDetailModel.isExpanded = !questionDetailModel.isExpanded">
        <i class="fas fa-angle-right" show.bind="!questionDetailModel.isExpanded"></i>
        <i class="fas fa-angle-down" show.bind="questionDetailModel.isExpanded"></i>
        <i class="fas ${(questionDetailModel.isGlobal ? 'fa-globe' : 'fa-flag')}" title="${(questionDetailModel.isGlobal ? 'Global question' : 'Country specific question')}"></i>&nbsp;<span as-element="af-highlight" text.bind="model.name" highlight.bind="filterText"></span>
      </h5>
      <div class="sc-buttons-container text-nowrap" style="text-align: right; margin-left: auto;">
        <button type="button" class="btn btn-danger" af-mutex-click.call="archive()" if.bind="archiveButtonVisible" title="Click to archive this question" bs-tooltip>
          <i class="fas fa-trash"></i>
        </button>
        <button type="button" class="btn btn-success" af-mutex-click.call="restore()" if.bind="restoreButtonVisible" title="Click to restore this question" bs-tooltip>
          <i class="fas fa-trash-restore"></i>
        </button>
      </div>
    </div>
    <div if.bind="questionDetailModel.isExpanded" class="ml-2 mb-2">
      <div class="form-row">
        <div class="col">
          <bs-form-textarea label="Question" placeholder="Question" value.bind="model.name & validate" disabled.bind="!model.isActive"></bs-form-textarea>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-4 col-lg-3 col-xl-2">
          <bs-form-switch text="Mandatory" checked.bind="model.isMandatory" disabled.bind="!model.isActive"></bs-form-switch>
        </div>
        <div class="col-sm-8 col-lg-9 col-xl-10">
          <bs-form-switch text="Checked by default" checked.bind="model.isDefaultChecked" disabled.bind="!model.isActive"></bs-form-switch>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="sc-buttons-container text-nowrap" style="text-align: right; margin-left: auto;">
            <button type="submit" class="btn btn-primary" af-mutex-click.call="submit()" if.bind="submitButtonVisible">
              <i class="fas fa-paper-plane"></i> ${model.id ? 'Save Changes' : 'Submit New'}
            </button>
            <button type="button" class="btn btn-light" af-mutex-click.call="cancel()" if.bind="cancelButtonVisible">
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div class="form-row" if.bind="model.id">
        <div class="col">
          <h6>Countries</h6>
          <as-widget-stack kind="admin-country-selector" widget-buttons.bind="countryButtons" new-item-widget-visible.bind="isCountryEditing" items.bind="questionDetailModel.countriesWrapper" add-new-item.call="addNewCountry(item)" remove-item.call="removeCountry(item)" empty-item-template.bind="newEmptyCountryWrapper" disabled.bind="!model.isActive"></as-widget-stack>
        </div>
      </div>
    </div>
  </div>
</template>
